
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { FontIcon } from "office-ui-fabric-react";
import { PAGES } from '../pagesDefinition';

const classNames = mergeStyleSets({
    previous: {
        color: '#666666',
        fontSize: '18px',
    },
    actual: {
        fontWeight: 'bold',
        color: '#000000',
        fontSize: '18px',
    },
    next: {
        color: '#aaaaaa',
        fontSize: '18px',
    },

    root: {
        backgroundColor: '#e2e2e2',
        display: 'flex',
        justifyContent: 'center',
    },

    container: {
        padding: '1em -2em',
        display: 'flex',
        justifyContent: 'space-between',
        width: '1024px'
    },

    icon: {
        paddingTop: '4px'
    }
});

const PageHeader = ({
    actualPage
}) => {
    return (
        <Stack horizontal className={classNames.root}>
            <Stack.Item>
                <Stack horizontal className={classNames.container}>
                    {PAGES.map(item => {

                        const separator = (item.id > 1)
                            ? <FontIcon className={classNames.icon} iconName="ChevronRightSmall"></FontIcon>
                            : null;

                        let className = classNames.previous;
                        if (item.id === actualPage) {
                            className = classNames.actual;
                        } else {
                            if (item.id > actualPage) {
                                className = classNames.next;
                            }
                        }

                        return [
                            <Stack.Item key={item.id-0.5}>
                                {separator}
                            </Stack.Item>,
                            <Stack.Item key={item.id}>
                                <span className={className}>{item.title}</span>
                            </Stack.Item>
                        ];
                    })}
                </Stack>
            </Stack.Item>
        </Stack>
    )
}

export default PageHeader;
